import { Component, OnInit } from '@angular/core';

import { Campus }        from 'src/app/core/models/api/campus.model';
import { CampusService } from 'src/app/core/services/api/campus.service';

@Component({
    selector: 'app-professorate',
    templateUrl: './professorate.component.html',
    styleUrls: ['./professorate.component.scss']
})
export class ProfessorateComponent implements OnInit {

    public campus: Campus;
    public webResourceId: string = "professorate-page";
    
    constructor(private campusService: CampusService) { }

    ngOnInit() {

        this.campus = this.campusService.campusActive;

    }

}
